/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpSharedContactDealerButton_user = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedContactDealerButton_user",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_user",
      "args": null
    }
  ],
  "type": "User"
};

module.exports = fragment;
